module.exports = __webpack_public_path__ + "img/share-modal.0f8e4680.png";